import { render, staticRenderFns } from "./AnomalyDescriptionDialog.vue?vue&type=template&id=0b172e48&scoped=true&"
import script from "./AnomalyDescriptionDialog.vue?vue&type=script&lang=js&"
export * from "./AnomalyDescriptionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b172e48",
  null
  
)

export default component.exports